import { computed, ref, unref } from 'vue'
import { useApplicationImport } from '@shared/lib'

export const useFormApplicationImport = ({
  applications,
  formId = null,
  onFinished = null,
} = {}) => {
  const selectedApplication = ref(null)

  const currentApplications = computed(() => unref(applications) ?? [])
  const importingApplication = computed(() => {
    const selectedApplicationId = selectedApplication.value?.id

    return currentApplications.value.find(application => application.import_status === 'importing') ||
      currentApplications.value.find(application => String(application.id) === String(selectedApplicationId)) ||
      selectedApplication.value
  })

  const {
    progressMessage,
    isImporting,
    startImport: startApplicationImport,
  } = useApplicationImport({
    application: importingApplication,
    formId,
    onFinished,
  })

  const importingApplicationId = computed(() => {
    if (!isImporting.value) return null
    return importingApplication.value?.id
  })

  const isApplicationImporting = application => String(importingApplicationId.value) === String(application.id)

  const startImport = (application) => {
    if (isImporting.value) return

    selectedApplication.value = application
    startApplicationImport()
  }

  return {
    progressMessage,
    isImporting,
    startImport,
    isApplicationImporting,
  }
}
